
class CountrySiteSwitch {
  constructor(domainConfig) {
    // 设置跳转连接
    this.urlObj = Object.assign(
      {
        old_c: "main",
        new_c: "EU",
        new_c_url: "https://viwoods-eu.com",
        good_url: "https://viwoods-eu.com/products",
      },
      domainConfig,
    );
    // 弹窗实例缓存
    this.confirmModal = null;
    // 欧盟国家码常量（只定义一次）
    this.EUCountryCodes = [
      "AT",
      "BE",
      "BG",
      "HR",
      "CY",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "HU",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PL",
      "PT",
      "RO",
      "SK",
      "SI",
      "ES",
      "SE",
    ];
    this.initData();
  }

  async initData() {
    // 时间检测
    const storageKey = "last_ip_check_time";
    var threeHourMs = 3 * 60 * 60 * 1000;
    var threeHourMs = 3 * 60 * 1000;
    // 调用封装函数判断冷却
    if (!this.canRunCheck(storageKey, threeHourMs)) {
      console.log("Please wait for 3 hours before checking again. Thank you! ");
      return;
    }
    try {
      const res = await fetch(
        "https://api.ipinfo.io/lite/me?token=07c19ec3f8f6cb",
      );
      const data = await res.json();
      console.info("IP地区信息", data);
      const countryCode = data.country_code || null;
      //
      const main_url = window.location.hostname;
      // 获取到数据之后可以
      if (countryCode) {
        console.log(main_url, countryCode, "==>");
        // this.showConfirmModal();
        // 实际ip欧盟
        if (this.EUCountryCodes.includes(countryCode)) {
          if (main_url == "viwoods.com") {
            this.urlObj = {
              old_c: "US site",
              new_c: "EU site",
              new_c_url: "https://viwoods-eu.com",
              good_url: "https://viwoods-eu.com/products",
            };
            this.showConfirmModal();
          }
          if (main_url == "uk.viwoods.com") {
            this.urlObj = {
              old_c: "UK site",
              new_c: "EU site",
              new_c_url: "https://viwoods-eu.com",
              good_url: "https://viwoods-eu.com/products",
            };
            this.showConfirmModal();
          }
        } else if (countryCode == "UK") {
          // 英国
          if (main_url == "viwoods.com") {
            this.urlObj = {
              old_c: "US site",
              new_c: "UK site",
              new_c_url: "https://uk.viwoods.com/",
              good_url: "https://uk.viwoods.com/products",
            };
            this.showConfirmModal();
          }
          if (main_url == "viwoods-eu.com") {
            this.urlObj = {
              old_c: "EU site",
              new_c: "UK site",
              new_c_url: "https://uk.viwoods.com/",
              good_url: "https://uk.viwoods.com/products",
            };
            this.showConfirmModal();
          }
        } else {
          // 美国 -主要站点
          if (main_url == "uk.viwoods.com") {
            this.urlObj = {
              old_c: "UK site",
              new_c: "US site",
              new_c_url: "https://viwoods.com/",
              good_url: "https://viwoods.com/products",
            };
            this.showConfirmModal();
          }
          if (main_url == "viwoods-eu.com") {
            this.urlObj = {
              old_c: "EU site",
              new_c: "US site",
              new_c_url: "https://viwoods.com/",
              good_url: "https://viwoods.com/products",
            };
            this.showConfirmModal();
          }
        }
      }
    } catch (error) {
      console.error("IP地址查询失败:", error);
    }
    // 更新执行时间
    this.updateCheckTime(storageKey);
  }

  /**
   * 工具函数：判断是否满足冷却时间
   * @param {string} storageKey 本地存储key
   * @param {number} coolMs 冷却毫秒数
   * @returns {boolean} true=可以执行 false=冷却中
   */
  canRunCheck(storageKey, coolMs) {
    const now = Date.now();
    const lastTime = Number(localStorage.getItem(storageKey)) || 0;
    const diff = now - lastTime;
    console.log(diff, coolMs, diff >= coolMs);
    return diff >= coolMs;
  }

  /**
   * 工具函数：更新执行时间戳
   * @param {string} storageKey 本地存储key
   */
  updateCheckTime(storageKey) {
    localStorage.setItem(storageKey, Date.now().toString());
  }
  // 动态创建单次确认弹窗（双自定义按钮）
  createConfirmModal() {
    let old_c = this.urlObj.old_c;
    let new_c = this.urlObj.new_c;
    if (this.confirmModal) return this.confirmModal;

    // 1. 弹窗容器
    const modal = document.createElement("div");
    modal.style.cssText = `
      position: fixed;
      top:0px;
      left: 50%;
      transform: translate(-50%, 300px);
      padding: 24px;
      background: #ffffff;
      border-radius: 8px;
      z-index: 99999;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      max-width:450px;
      width:90%;
      box-sizing: border-box;
      display: none;
      position:fixed;
    `;

    // 2. 标题
    const confirmText = document.createElement("div");
    confirmText.style.cssText = `
      width:100%;
      font-size: 16px;
      color: #333333;
      line-height: 1.5;
      text-align: center;
      margin-bottom:12px; 
      font-weight: bold;
    `;
    confirmText.textContent = `It seems you are in ${old_c}`;
    modal.appendChild(confirmText);

    // 2. 提示文本（通用提示）
    const confirmText2 = document.createElement("div");
    confirmText2.style.cssText = `
      width:100%;
      font-size: 16px;
      color: #333333;
      line-height: 1.5;
      height:20px;
      text-align: center;
      margin-bottom:12px; 
    `;
    confirmText2.textContent = `Would you like to visit the ${new_c} website?`;
    modal.appendChild(confirmText2);

    // 3. 按钮容器
    const btnContainer = document.createElement("div");
    btnContainer.style.cssText = `
      display: flex;
      gap: 12px;
      justify-content: center;
      margin-bottom:12px; 
    `;
    modal.appendChild(btnContainer);

    // 4. 按钮1：提交表单
    const submitBtn = document.createElement("button");
    submitBtn.style.cssText = `
      padding: 8px 0px;
      width:80%;
      background: #000000;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      transition: opacity 0.2s;
      display:none;
    `;
    submitBtn.textContent = "Yes, please";
    submitBtn.onmouseover = () => (submitBtn.style.opacity = "0.9");
    submitBtn.onmouseout = () => (submitBtn.style.opacity = "1");
    btnContainer.appendChild(submitBtn);

    // 5. 按钮2：跳转站点
    const jumpBtn = document.createElement("button");
    jumpBtn.style.cssText = `
      padding: 8px 0px;
      width:80%;
      background: #000000;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      color: #fff;
      transition: opacity 0.2s;
    `;
    jumpBtn.textContent = `Yes, please`;
    jumpBtn.onmouseover = () => (jumpBtn.style.opacity = "0.9");
    jumpBtn.onmouseout = () => (jumpBtn.style.opacity = "1");
    btnContainer.appendChild(jumpBtn);
    // 5.去产品看看
    const toGoodsList = document.createElement("div");
    toGoodsList.style.cssText = `
      margin: 0 0 20px 0;
      font-size: 16px;
      color: #333333;
      line-height: 1.5;
      text-align: center;
      text-decoration:underline;
      cursor: pointer;
    `;
    toGoodsList.textContent = "Explore the products first";
    modal.appendChild(toGoodsList);
    // 6. 右上角关闭按钮
    const cancelBtn = document.createElement("button");
    cancelBtn.style.cssText = `
      position:absolute; 
      top:6px; 
      right:6px;
      width:28px; 
      height:28px;
      border-radius:50%; 
      background:#f6f6f6;
      display:flex; 
      align-items:center; 
      justify-content:center;
      font-size:28px; 
      color:#555; 
      cursor:pointer;
      border: none;
      outline: none;
      padding: 0;
    `;
    cancelBtn.innerHTML = `
     <svg t="1776599070058" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2454" width="32" height="32">
     <path d="M512 70.772034c-243.685892 0-441.227966 197.550776-441.227966 441.227966 0 243.685892 197.542074 441.227966 441.227966 441.227966S953.227966 755.685892 953.227966 512C953.227966 268.32281 755.685892 70.772034 512 70.772034zM713.983275 656.253462c15.919864 15.960476 15.919864 41.780941 0 57.700805-15.948873 15.960476-41.780941 15.960476-57.729813 0L512 569.712408l-144.294074 144.241858c-15.908261 15.960476-41.740329 15.960476-57.692102 0-15.908261-15.919864-15.908261-41.740329 0-57.700805l144.28247-144.241858-144.28247-144.28247c-15.908261-15.919864-15.908261-41.751932 0-57.700805 15.948873-15.919864 41.780941-15.919864 57.692102 0l144.294074 144.28247 144.253462-144.28247c15.948873-15.919864 41.780941-15.919864 57.729813 0 15.919864 15.948873 15.919864 41.780941 0 57.700805l-144.28247 144.28247L713.983275 656.253462z" fill="#272636" p-id="2455"></path></svg>    
     `;
    cancelBtn.onmouseover = () => (cancelBtn.style.background = "#f9f9f9");
    cancelBtn.onmouseout = () => (cancelBtn.style.background = "#f6f6f6");
    modal.appendChild(cancelBtn);

    // 7. 遮罩层
    const mask = document.createElement("div");
    mask.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      z-index: 99998;
      display: none;
    `;

    // 8. 存储弹窗实例
    this.confirmModal = {
      toGoodsList,
      modal,
      mask,
      submitBtn,
      jumpBtn,
      cancelBtn,
    };

    // 9. 添加到页面
    document.body.appendChild(mask);
    document.body.appendChild(modal);
    return this.confirmModal;
  }

  // 显示弹窗
  showConfirmModal() {
    const modal = this.createConfirmModal();
    const _this = this;

    // 按钮点击事件
    modal.submitBtn.onclick = () => {
      if (_this.elements.form) _this.elements.form.submit();
      _this.hideConfirmModal();
    };
    modal.jumpBtn.onclick = () => {
      _this.handleJump(_this.urlObj.new_c_url);
      _this.hideConfirmModal();
    };
    modal.cancelBtn.onclick = () => this.hideConfirmModal();
    modal.mask.onclick = () => this.hideConfirmModal();
    // 产品页面
    modal.toGoodsList.onclick = () => {
      _this.hideConfirmModal();
      _this.handleJump(this.urlObj.good_url);
    };
    // 展示弹窗+遮罩
    modal.modal.style.display = "block";
    modal.mask.style.display = "block";
  }

  // 隐藏弹窗
  hideConfirmModal() {
    if (!this.confirmModal) return;
    this.confirmModal.modal.style.display = "none";
    this.confirmModal.mask.style.display = "none";
  }
  // 站点跳转逻辑
  handleJump(targetUrl) {
    window.location.href = targetUrl;
  }
}
window.addEventListener('DOMContentLoaded', function() {
  // 点击滚动
  try {
    const view_btn = document.querySelector(".rating-badge");
    const target = document.querySelector("#judgeme_product_reviews");
    view_btn.addEventListener("click", () => {
      console.log(view_btn, "ssss", target, "tttt");
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
    console.log("评价滚动功能已加载");
  } catch (error) {
    console.log(error, "滚动到指定div");
  }

  // 滚动相关
  document.addEventListener('shopify:section:load', (event) => {
    // 首页滚动
    if(window && window.initflickityBanner){
      try {
        const bannerInstance = window.initflickityBanner('.vi-banner-slider');   
      } catch (error) {
        console.log(error, 'bannerInstance');
      }
    }
    // 产品推荐滚动
    if(window && window.initflickityProductlist){
      try {
        const bannerInstance = window.initflickityProductlist('.index-product-scroll'); 
      } catch (error) {
        console.log(error, 'bannerInstance');
      }
    }
    // 购物车抽屉滚动
    if(window && window.initFlickityForDrawer){
      try {
        const bannerInstance = window.initFlickityForDrawer(); 
      } catch (error) {
        console.log(error, 'initFlickityForDrawer');
      }
    }

    // 图片滚动
    if(window && window.initflickityImageslist){
      try {
        const bannerInstance = window.initflickityImageslist('.vi-main-carousel')
      } catch (error) {
        console.log(error, 'initFlickityForDrawer');
      }
    }
    //index-imagetxt-scroll 土拍你和文字一起滚动
    if(window && window.initflickityImagetxt){
      try {
        const bannerInstance = window.initflickityImagetxt('.vi-maintxt-carousel')
      } catch (error) {
        console.log(error, 'initflickityImagetxt');
      }
    }
    // multicolumn icon-scroll 图标滚动
    if(window && window.initflickityIconScroll){
      try {
        const bannerInstance = window.initflickityIconScroll('.vi-maintxt-carousel')
      } catch (error) {
        console.log(error, 'initflickityIconScroll');
      }
    }

    // index-compare 对比滚动 图标滚动
    if(window && window.initflickityCompare){
      try {
        const bannerInstance = window.initflickityCompare('.product-grid-mobile');   
      } catch (error) {
        console.log(error, 'initflickityCompare');
      }
    }
    // index-small-tips 图标滚动
    if(window && window.initflickityIconlist){
      try {
        const bannerInstance = window.initflickityIconlist('.vi-items-wrapper-mobile');   
      } catch (error) {
        console.log(error, 'initflickityIconlist');
      }
    }
    // index-imnageText-list
    if(window && window.initflickitySixImage){
      try {
         const bannerInstance = window.initflickitySixImage('.vi-spec-grid-mobile');   
      } catch (error) {
        console.log(error, 'initflickitySixImage');
      }
    }
    // 初始化弹窗
    try {
      const switcher = new CountrySiteSwitch();
    } catch (error) {
      console.log("初始化switcher失败:", error);
    }
  });
})